// extracted by mini-css-extract-plugin
export default {"notfound":"css_notfound__nQ8Ok"};